$( ".show__more" ).click(function() {
    $(this).siblings().addClass("active");
    $(this).addClass("active");
  });